<template>
  <div class="db-wrap">
    <ProgressBar v-if="loader" mode="indeterminate" style="height:3px;position:fixed;top:0;left:0;right:0;z-index:9999;border-radius:0" />

    <TabView>
      <!-- ══ TAB 1: PANEL OPERATIVO ══ -->
      <TabPanel>
        <template #header><i class="pi pi-desktop mr-2"></i>Panel Operativo</template>
        <PanelOperativo
          @ver-soat="$router.push('/vehiculos?filtro=soat')"
          @ver-rtm="$router.push('/vehiculos?filtro=rtm')"
          @ver-licencias="$router.push('/conductores?filtro=licencias')"
          @ver-antecedentes="$router.push('/conductores?filtro=antecedentes')"
        />
      </TabPanel>

      <!-- ══ TAB 2: PANEL CONTABLE ══ -->
      <!-- <TabPanel>
        <template #header><i class="pi pi-chart-bar mr-2"></i>Panel Contable</template>

        <div class="ct-dashboard">

          ── Barra superior ──
          <div class="ct-topbar">
            <div>
              <h2 class="ct-title">Panel Contable</h2>
              <p class="ct-subtitle">Resumen financiero y operativo</p>
            </div>
          </div>

          ── KPI totales ──
          <div class="ct-kpi-grid">
            <div class="ct-kpi-card">
              <div class="ct-kpi-icon" style="background:#eff6ff"><i class="pi pi-users" style="color:#3b82f6"></i></div>
              <div>
                <div class="ct-kpi-label">CARTERA TOTAL</div>
                <div class="ct-kpi-value">{{ fmtNum(total_cartera) }}</div>
              </div>
            </div>
            <div class="ct-kpi-card">
              <div class="ct-kpi-icon" style="background:#f0fdf4"><i class="pi pi-wallet" style="color:#22c55e"></i></div>
              <div>
                <div class="ct-kpi-label">INGRESOS TOTALES</div>
                <div class="ct-kpi-value">{{ fmtNum(total_ingreso) }}</div>
              </div>
            </div>
            <div class="ct-kpi-card">
              <div class="ct-kpi-icon" style="background:#fff7ed"><i class="pi pi-file-edit" style="color:#f97316"></i></div>
              <div>
                <div class="ct-kpi-label">FACTURADO</div>
                <div class="ct-kpi-value">{{ fmtNum(total_facturado) }}</div>
              </div>
            </div>
            <div class="ct-kpi-card">
              <div class="ct-kpi-icon" style="background:#eff6ff"><i class="pi pi-check-circle" style="color:#06b6d4"></i></div>
              <div>
                <div class="ct-kpi-label">PAGADO</div>
                <div class="ct-kpi-value">{{ fmtNum(total_pagado) }}</div>
              </div>
            </div>
            <div class="ct-kpi-card">
              <div class="ct-kpi-icon" style="background:#fef2f2"><i class="pi pi-chart-line" style="color:#ef4444"></i></div>
              <div>
                <div class="ct-kpi-label">GASTO TOTAL</div>
                <div class="ct-kpi-value">{{ fmtNum(total_gasto) }}</div>
              </div>
            </div>
            <div class="ct-kpi-card">
              <div class="ct-kpi-icon" style="background:#faf5ff"><i class="pi pi-dollar" style="color:#8b5cf6"></i></div>
              <div>
                <div class="ct-kpi-label">RECAUDO</div>
                <div class="ct-kpi-value">{{ fmtNum(total_recaudo) }}</div>
              </div>
            </div>
            <div class="ct-kpi-card">
              <div class="ct-kpi-icon" style="background:#fdf2f8"><i class="pi pi-shopping-cart" style="color:#ec4899"></i></div>
              <div>
                <div class="ct-kpi-label">COMPRAS</div>
                <div class="ct-kpi-value">{{ fmtNum(total_compras) }}</div>
              </div>
            </div>
            <div class="ct-kpi-card">
              <div class="ct-kpi-icon" style="background:#fff7ed"><i class="pi pi-arrow-up" style="color:#f97316"></i></div>
              <div>
                <div class="ct-kpi-label">EGRESOS VARIOS</div>
                <div class="ct-kpi-value">{{ fmtNum(total_egreso) }}</div>
              </div>
            </div>
          </div>

          ── FILA 1: Cartera (donut) + Ingresos (donut) ──
          <div class="ct-section-label">Cartera e ingresos</div>
          <div class="ct-charts-grid">
            <div class="ct-chart-card">
              <div class="ct-chart-header">
                <div><div class="ct-chart-title">Cartera por generador</div><div class="ct-chart-sub">Top generadores con mayor saldo</div></div>
                <button class="ct-link-btn" @click="openmodalCarteraCompleta">Ver todos <i class="pi pi-arrow-right"></i></button>
              </div>
              <div class="ct-chart-body">
                <div class="ct-donut-wrap">
                  <canvas :ref="el => cvs.cartera = el" width="180" height="180"></canvas>
                  <div class="ct-donut-center"><div class="ct-donut-val">{{ fmtCOP(total_cartera) }}</div><div class="ct-donut-lbl">TOTAL</div></div>
                </div>
                <div class="ct-legend">
                  <div class="ct-legend-item" v-for="(item, i) in carteraLegend" :key="i">
                    <div class="ct-legend-dot" :style="{ background: item.color }"></div>
                    <div class="ct-legend-label">{{ item.label }}</div>
                    <div class="ct-legend-val">{{ fmtCOP(item.value) }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ct-chart-card">
              <div class="ct-chart-header">
                <div><div class="ct-chart-title">Ingreso por sucursal</div><div class="ct-chart-sub">Distribución de ingresos</div></div>
                <button class="ct-link-btn" @click="openmodalIngreso">Ampliar <i class="pi pi-arrow-right"></i></button>
              </div>
              <div class="ct-chart-body">
                <div class="ct-donut-wrap">
                  <canvas :ref="el => cvs.ingreso = el" width="180" height="180"></canvas>
                  <div class="ct-donut-center"><div class="ct-donut-val">{{ fmtCOP(total_ingreso) }}</div><div class="ct-donut-lbl">TOTAL</div></div>
                </div>
                <div class="ct-legend">
                  <div class="ct-legend-item" v-for="(item, i) in ingresoLegend" :key="i">
                    <div class="ct-legend-dot" :style="{ background: item.color }"></div>
                    <div class="ct-legend-label">{{ item.label }}</div>
                    <div class="ct-legend-val">{{ fmtCOP(item.value) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          ── FILA 2: Facturado (barH) + Pagado (barH) ──
          <div class="ct-section-label">Facturación y pagos por sucursal</div>
          <div class="ct-charts-grid">
            <div class="ct-chart-card">
              <div class="ct-chart-header">
                <div><div class="ct-chart-title">Facturado por sucursal</div><div class="ct-chart-sub">Total: {{ fmtNum(total_facturado) }}</div></div>
                <button class="ct-link-btn" @click="openmodalFacturado">Ampliar <i class="pi pi-arrow-right"></i></button>
              </div>
              <div class="ct-bar-body"><canvas :ref="el => cvs.facturado = el"></canvas></div>
            </div>
            <div class="ct-chart-card">
              <div class="ct-chart-header">
                <div><div class="ct-chart-title">Pagado por sucursal</div><div class="ct-chart-sub">Total: {{ fmtNum(total_pagado) }}</div></div>
                <button class="ct-link-btn" @click="openmodalPagado">Ampliar <i class="pi pi-arrow-right"></i></button>
              </div>
              <div class="ct-bar-body"><canvas :ref="el => cvs.pagado = el"></canvas></div>
            </div>
          </div>

          ── FILA 3: Gasto (barH) + Recaudo (barH) ──
          <div class="ct-section-label">Gastos y recaudos por sucursal</div>
          <div class="ct-charts-grid">
            <div class="ct-chart-card">
              <div class="ct-chart-header">
                <div><div class="ct-chart-title">Gasto por sucursal</div><div class="ct-chart-sub">Total: {{ fmtNum(total_gasto) }}</div></div>
                <button class="ct-link-btn" @click="openmodalGastado">Ampliar <i class="pi pi-arrow-right"></i></button>
              </div>
              <div class="ct-bar-body"><canvas :ref="el => cvs.gasto = el"></canvas></div>
            </div>
            <div class="ct-chart-card">
              <div class="ct-chart-header">
                <div><div class="ct-chart-title">Recaudo por sucursal</div><div class="ct-chart-sub">Total: {{ fmtNum(total_recaudo) }}</div></div>
                <button class="ct-link-btn" @click="openmodalRecaudo">Ampliar <i class="pi pi-arrow-right"></i></button>
              </div>
              <div class="ct-bar-body"><canvas :ref="el => cvs.recaudo = el"></canvas></div>
            </div>
          </div>

          ── FILA 4: Compras (donut) + Egresos (donut) ──
          <div class="ct-section-label">Compras y egresos varios</div>
          <div class="ct-charts-grid">
            <div class="ct-chart-card">
              <div class="ct-chart-header">
                <div><div class="ct-chart-title">Compras por sucursal</div><div class="ct-chart-sub">Total: {{ fmtNum(total_compras) }}</div></div>
                <button class="ct-link-btn" @click="openmodalCompras">Ampliar <i class="pi pi-arrow-right"></i></button>
              </div>
              <div class="ct-chart-body">
                <div class="ct-donut-wrap">
                  <canvas :ref="el => cvs.compras = el" width="180" height="180"></canvas>
                  <div class="ct-donut-center"><div class="ct-donut-val">{{ fmtCOP(total_compras) }}</div><div class="ct-donut-lbl">TOTAL</div></div>
                </div>
                <div class="ct-legend">
                  <div class="ct-legend-item" v-for="(item, i) in comprasLegend" :key="i">
                    <div class="ct-legend-dot" :style="{ background: item.color }"></div>
                    <div class="ct-legend-label">{{ item.label }}</div>
                    <div class="ct-legend-val">{{ fmtCOP(item.value) }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ct-chart-card">
              <div class="ct-chart-header">
                <div><div class="ct-chart-title">Egresos varios</div><div class="ct-chart-sub">Total: {{ fmtNum(total_egreso) }}</div></div>
                <button class="ct-link-btn" @click="openmodalEgreso">Ampliar <i class="pi pi-arrow-right"></i></button>
              </div>
              <div class="ct-chart-body">
                <div class="ct-donut-wrap">
                  <canvas :ref="el => cvs.egreso = el" width="180" height="180"></canvas>
                  <div class="ct-donut-center"><div class="ct-donut-val">{{ fmtCOP(total_egreso) }}</div><div class="ct-donut-lbl">TOTAL</div></div>
                </div>
                <div class="ct-legend">
                  <div class="ct-legend-item" v-for="(item, i) in egresoLegend" :key="i">
                    <div class="ct-legend-dot" :style="{ background: item.color }"></div>
                    <div class="ct-legend-label">{{ item.label }}</div>
                    <div class="ct-legend-val">{{ fmtCOP(item.value) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </TabPanel> -->
    </TabView>

    <!-- ══ MODALES AMPLIADOS ══ -->
    <!-- Cartera completa -->
    <!-- <Dialog v-model:visible="modal_cartera" :style="{width: '80vw'}" header="Cartera por generador" :modal="true" class="ct-dialog">
      <div class="ct-modal-total"><span class="ct-modal-total-label">Total</span><span class="ct-modal-total-val">{{ fmtNum(total_cartera) }}</span></div>
      <div class="ct-modal-chart-wrap"><canvas :ref="el => mCvs.cartera = el"></canvas></div>
      <template #footer><Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_cartera = false"/></template>
    </Dialog> -->

    <!-- Ingreso -->
    <!-- <Dialog v-model:visible="modal_ingreso" :style="{width: '80vw'}" header="Ingreso por sucursal" :modal="true" class="ct-dialog">
      <div class="ct-modal-total"><span class="ct-modal-total-label">Total</span><span class="ct-modal-total-val">{{ fmtNum(total_ingreso) }}</span></div>
      <div class="ct-modal-chart-wrap"><canvas :ref="el => mCvs.ingreso = el"></canvas></div>
      <template #footer><Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_ingreso = false"/></template>
    </Dialog> -->

    <!-- Facturado -->
    <!-- <Dialog v-model:visible="modal_facturado" :style="{width: '80vw'}" header="Facturado por sucursal" :modal="true" class="ct-dialog">
      <div class="ct-modal-total"><span class="ct-modal-total-label">Total</span><span class="ct-modal-total-val">{{ fmtNum(total_facturado) }}</span></div>
      <div class="ct-modal-chart-wrap ct-modal-chart-wrap--bar"><canvas :ref="el => mCvs.facturado = el"></canvas></div>
      <template #footer><Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_facturado = false"/></template>
    </Dialog> -->

    <!-- Pagado -->
    <!-- <Dialog v-model:visible="modal_pagado" :style="{width: '80vw'}" header="Pagado por sucursal" :modal="true" class="ct-dialog">
      <div class="ct-modal-total"><span class="ct-modal-total-label">Total</span><span class="ct-modal-total-val">{{ fmtNum(total_pagado) }}</span></div>
      <div class="ct-modal-chart-wrap ct-modal-chart-wrap--bar"><canvas :ref="el => mCvs.pagado = el"></canvas></div>
      <template #footer><Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_pagado = false"/></template>
    </Dialog> -->

    <!-- Gasto -->
    <!-- <Dialog v-model:visible="modal_gastado" :style="{width: '80vw'}" header="Gasto por sucursal" :modal="true" class="ct-dialog">
      <div class="ct-modal-total"><span class="ct-modal-total-label">Total</span><span class="ct-modal-total-val">{{ fmtNum(total_gasto) }}</span></div>
      <div class="ct-modal-chart-wrap ct-modal-chart-wrap--bar"><canvas :ref="el => mCvs.gasto = el"></canvas></div>
      <template #footer><Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_gastado = false"/></template>
    </Dialog> -->

    <!-- Recaudo -->
    <!-- <Dialog v-model:visible="modal_recaudo" :style="{width: '80vw'}" header="Recaudo por sucursal" :modal="true" class="ct-dialog">
      <div class="ct-modal-total"><span class="ct-modal-total-label">Total</span><span class="ct-modal-total-val">{{ fmtNum(total_recaudo) }}</span></div>
      <div class="ct-modal-chart-wrap ct-modal-chart-wrap--bar"><canvas :ref="el => mCvs.recaudo = el"></canvas></div>
      <template #footer><Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_recaudo = false"/></template>
    </Dialog> -->

    <!-- Egreso -->
    <!-- <Dialog v-model:visible="modal_egreso" :style="{width: '80vw'}" header="Egresos varios" :modal="true" class="ct-dialog">
      <div class="ct-modal-total"><span class="ct-modal-total-label">Total</span><span class="ct-modal-total-val">{{ fmtNum(total_egreso) }}</span></div>
      <div class="ct-modal-chart-wrap"><canvas :ref="el => mCvs.egreso = el"></canvas></div>
      <template #footer><Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_egreso = false"/></template>
    </Dialog> -->

    <!-- Compras -->
    <!-- <Dialog v-model:visible="modal_compras" :style="{width: '80vw'}" header="Compras por sucursal" :modal="true" class="ct-dialog">
      <div class="ct-modal-total"><span class="ct-modal-total-label">Total</span><span class="ct-modal-total-val">{{ fmtNum(total_compras) }}</span></div>
      <div class="ct-modal-chart-wrap"><canvas :ref="el => mCvs.compras = el"></canvas></div>
      <template #footer><Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_compras = false"/></template>
    </Dialog> -->
  </div>
</template>

<script>
import PanelOperativo from './PanelOperativo.vue';

export default {
  components: { PanelOperativo },

  data() {
    return {
      loader: false,
      saldos: [], egresos: [], recaudos: [], compras: [], indicadores_contables: [],
      total_cartera:0, total_ingreso:0, total_facturado:0, total_pagado:0,
      total_gasto:0, total_egreso:0, total_recaudo:0, total_compras:0,
      carteraLegend:[], ingresoLegend:[], comprasLegend:[], egresoLegend:[],
      // canvas refs (inline charts)
      cvs: { cartera:null, ingreso:null, facturado:null, pagado:null, gasto:null, recaudo:null, compras:null, egreso:null },
      charts: { cartera:null, ingreso:null, facturado:null, pagado:null, gasto:null, recaudo:null, compras:null, egreso:null },
      // modal canvas refs
      mCvs: { cartera:null, ingreso:null, facturado:null, pagado:null, gasto:null, recaudo:null, compras:null, egreso:null },
      mCharts: {},
      // modals
      modal_cartera:false, modal_ingreso:false, modal_facturado:false, modal_pagado:false,
      modal_gastado:false, modal_egreso:false, modal_recaudo:false, modal_compras:false,
    };
  },

  // mounted() { this.cargarDatos(); },
  beforeUnmount() {
    [...Object.values(this.charts), ...Object.values(this.mCharts)].forEach(c => c?.destroy?.());
  },

  watch: {
    modal_cartera(v)  { if (v) this.$nextTick(() => this._modalDonut('cartera',  this.saldos,               s => s.razon_social || s.nombre_ini, s => s.saldo)); },
    modal_ingreso(v)  { if (v) this.$nextTick(() => this._modalDonut('ingreso',   this.indicadores_contables, s => s.sucursal,     s => s.ingreso,  s => s.color)); },
    modal_facturado(v){ if (v) this.$nextTick(() => this._modalBarH('facturado',  this.indicadores_contables, s => s.sucursal, s => s.facturado, s => s.color)); },
    modal_pagado(v)   { if (v) this.$nextTick(() => this._modalBarH('pagado',     this.indicadores_contables, s => s.sucursal, s => s.pagado,    s => s.color)); },
    modal_gastado(v)  { if (v) this.$nextTick(() => this._modalBarH('gasto',      this.indicadores_contables, s => s.sucursal, s => s.gastado,   s => s.color)); },
    modal_recaudo(v)  { if (v) this.$nextTick(() => this._modalBarH('recaudo',    this.recaudos,              s => s.sucursal, s => s.recaudo,   () => null)); },
    modal_egreso(v)   { if (v) this.$nextTick(() => this._modalDonut('egreso',    this.egresos,               s => s.sucursal, s => s.egreso)); },
    modal_compras(v)  { if (v) this.$nextTick(() => this._modalDonut('compras',   this.compras,               s => s.sucursal, s => s.compra)); },
  },

  methods: {
    cargarDatos() {
      this.loader = true;
      const cookie = {};
      document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });
      window.api.call('post', 'dashboard_empresas_transporte', { email: cookie['Email'], id_rol: cookie['IdRol'] })
        .then(res => {
          if (res.status === 200) {
            this.saldos                = res.data.data               ?? [];
            this.egresos               = res.data.egresos             ?? [];
            this.indicadores_contables = res.data.indicadores_contables ?? [];
            this.recaudos              = res.data.recaudos             ?? [];
            this.compras               = res.data.compras              ?? [];
            this._calcularTotales();
            this.$nextTick(() => this._renderInline());
          }
        })
        .catch(e => console.error(e))
        .finally(() => { this.loader = false; });
    },

    _calcularTotales() {
      this.total_cartera   = this.saldos.reduce((a,s) => a + (s.saldo ?? 0), 0);
      this.total_ingreso   = this.indicadores_contables.reduce((a,s) => a + (s.ingreso ?? 0), 0);
      this.total_facturado = this.indicadores_contables.reduce((a,s) => a + (s.facturado ?? 0), 0);
      this.total_pagado    = this.indicadores_contables.reduce((a,s) => a + (s.pagado ?? 0), 0);
      this.total_gasto     = this.indicadores_contables.reduce((a,s) => a + (s.gastado ?? 0), 0);
      this.total_egreso    = this.egresos.reduce((a,s) => a + (s.egreso ?? 0), 0);
      this.total_recaudo   = this.recaudos.reduce((a,s) => a + (s.recaudo ?? 0), 0);
      this.total_compras   = this.compras.reduce((a,s) => a + (s.compra ?? 0), 0);
      // Leyendas (top 6 para la vista inline)
      this.carteraLegend = [...this.saldos].sort((a,b)=>(b.saldo??0)-(a.saldo??0)).slice(0,6).map(s=>({label:s.razon_social,value:s.saldo??0,color:this._rndColor()}));
      this.ingresoLegend = this.indicadores_contables.slice(0,6).map(s=>({label:this._truncate(s.sucursal,22),value:s.ingreso??0,color:s.color||this._rndColor()}));
      this.comprasLegend = this.compras.slice(0,6).map(s=>({label:this._truncate(s.sucursal,22),value:s.compra??0,color:this._rndColor()}));
      this.egresoLegend  = this.egresos.slice(0,6).map(s=>({label:this._truncate(s.sucursal,22),value:s.egreso??0,color:this._rndColor()}));
    },

    _renderInline() {
      // Donuts
      this._donut('cartera', this.saldos.slice(0,8).map(s=>s.saldo??0), this.carteraLegend.map(i=>i.color));
      this._donut('ingreso',  this.indicadores_contables.slice(0,8).map(s=>s.ingreso??0), this.ingresoLegend.map(i=>i.color));
      this._donut('compras',  this.compras.slice(0,8).map(s=>s.compra??0), this.comprasLegend.map(i=>i.color));
      this._donut('egreso',   this.egresos.slice(0,8).map(s=>s.egreso??0), this.egresoLegend.map(i=>i.color));
      // Barras horizontales — reintentar con rAF si el canvas no tiene ancho aún
      this._barHReintento(0);
    },

    _barHReintento(intentos) {
      const cvF = this.cvs.facturado;
      const ancho = cvF ? (cvF.offsetWidth || cvF.parentElement?.offsetWidth || 0) : 0;
      if (ancho > 10 || intentos >= 10) {
        this._barH('facturado', this.indicadores_contables, s=>s.sucursal, s=>s.facturado??0, s=>s.color);
        this._barH('pagado',    this.indicadores_contables, s=>s.sucursal, s=>s.pagado??0,    s=>s.color);
        this._barH('gasto',     this.indicadores_contables, s=>s.sucursal, s=>s.gastado??0,   s=>s.color);
        this._barH('recaudo',   this.recaudos,              s=>s.sucursal, s=>s.recaudo??0,   () => null);
      } else {
        requestAnimationFrame(() => this._barHReintento(intentos + 1));
      }
    },

    // ── Donut canvas ────────────────────────────────────────────────────────
    _donut(key, vals, cols) {
      const cv = this.cvs[key]; if (!cv) return;
      this.charts[key]?.destroy?.();
      const ctx=cv.getContext('2d'),W=cv.width,H=cv.height,cx=W/2,cy=H/2,r=Math.min(W,H)/2-8,ri=r*.62;
      const total=vals.reduce((a,b)=>a+b,0)||1;
      ctx.clearRect(0,0,W,H);
      ctx.shadowColor='rgba(0,0,0,.05)'; ctx.shadowBlur=4;
      let a=-Math.PI/2;
      vals.forEach((v,i)=>{
        if(v<=0)return; const s=(v/total)*2*Math.PI;
        ctx.beginPath(); ctx.moveTo(cx,cy); ctx.arc(cx,cy,r,a,a+s); ctx.closePath();
        ctx.fillStyle=cols[i]||this._rndColor(); ctx.fill(); a+=s;
      });
      ctx.shadowBlur=0;
      ctx.beginPath(); ctx.arc(cx,cy,ri,0,2*Math.PI); ctx.fillStyle='#fff'; ctx.fill();
      this.charts[key]={destroy:()=>ctx.clearRect(0,0,W,H)};
    },

    // ── Barra horizontal ────────────────────────────────────────────────────
    _barH(key, data, fnLabel, fnVal, fnColor) {
		const cv = this.cvs[key]; if (!cv) return;
		this.charts[key]?.destroy?.();
		const labels = data.map(fnLabel), vals = data.map(fnVal);
		if (!labels.length) return;

		const BH=28, GAP=14, PL=110, PR=40, PT=16, PB=28;
		const totalH = PT + labels.length * (BH + GAP) + PB;

		const ancho = cv.offsetWidth
			|| cv.parentElement?.offsetWidth
			|| cv.parentElement?.parentElement?.offsetWidth
			|| 460;

		cv.width  = ancho;
		cv.height = totalH;
		// Quitar cualquier override de CSS que el !important pudiera aplicar
		cv.style.width  = ancho + 'px';
		cv.style.height = totalH + 'px';

		const ctx = cv.getContext('2d');
		const W = cv.width, dW = W - PL - PR, maxV = Math.max(...vals) || 1;
		ctx.clearRect(0, 0, W, totalH);

		const steps = 5;
		for (let i = 0; i <= steps; i++) {
			const x = PL + (dW / steps) * i;
			ctx.strokeStyle = '#e8eaed'; ctx.lineWidth = 1;
			ctx.beginPath(); ctx.moveTo(x, PT); ctx.lineTo(x, totalH - PB); ctx.stroke();
			ctx.fillStyle = '#9ca3af'; ctx.font = '11px system-ui'; ctx.textAlign = 'center';
			ctx.fillText(this.fmtCOP(Math.round((maxV / steps) * i)), x, totalH - 8);
		}

		labels.forEach((lbl, i) => {
			const y = PT + i * (BH + GAP), bW = (vals[i] / maxV) * dW, r = 4;
			const col = fnColor(data[i]) || '#1e3a5f';

			ctx.fillStyle = '#374151'; ctx.font = '12px system-ui'; ctx.textAlign = 'right';
			ctx.fillText(this._truncate(lbl, 18), PL - 8, y + BH / 2 + 4);

			ctx.fillStyle = col;
			ctx.beginPath();
			ctx.moveTo(PL + r, y); ctx.lineTo(PL + bW - r, y);
			ctx.quadraticCurveTo(PL + bW, y, PL + bW, y + r);
			ctx.lineTo(PL + bW, y + BH - r);
			ctx.quadraticCurveTo(PL + bW, y + BH, PL + bW - r, y + BH);
			ctx.lineTo(PL + r, y + BH);
			ctx.quadraticCurveTo(PL, y + BH, PL, y + BH - r);
			ctx.lineTo(PL, y + r);
			ctx.quadraticCurveTo(PL, y, PL + r, y);
			ctx.closePath(); ctx.fill();

			if (bW > 20) {
				ctx.fillStyle = '#6b7280'; ctx.font = '11px system-ui'; ctx.textAlign = 'left';
				ctx.fillText(this.fmtCOP(vals[i]), PL + bW + 5, y + BH / 2 + 4);
			}
		});

		this.charts[key] = { destroy: () => ctx.clearRect(0, 0, cv.width, cv.height) };
	},

    // ── Modal: donut grande ─────────────────────────────────────────────────
    _modalDonut(key, data, fnLabel, fnVal, fnColor) {
      const cv = this.mCvs[key]; if (!cv) return;
      this.mCharts[key]?.destroy?.();
      const labels=data.map(fnLabel), vals=data.map(fnVal);
      const cols=data.map((s,i)=>fnColor?.(s) || this._rndColor());
      const PL=240, PR=20, PT=20, PB=20;
      const H=380, r_donut=160, ri_donut=r_donut*.6;
      cv.width=cv.parentElement?.clientWidth||800; cv.height=H;
      const ctx=cv.getContext('2d'),W=cv.width;
      const cx=r_donut+PT, cy=H/2;
      ctx.clearRect(0,0,W,H);
      // donut
      const total=vals.reduce((a,b)=>a+b,0)||1;
      ctx.shadowColor='rgba(0,0,0,.05)'; ctx.shadowBlur=6;
      let a=-Math.PI/2;
      vals.forEach((v,i)=>{ if(v<=0)return; const s=(v/total)*2*Math.PI; ctx.beginPath(); ctx.moveTo(cx,cy); ctx.arc(cx,cy,r_donut,a,a+s); ctx.closePath(); ctx.fillStyle=cols[i]; ctx.fill(); a+=s; });
      ctx.shadowBlur=0;
      ctx.beginPath(); ctx.arc(cx,cy,ri_donut,0,2*Math.PI); ctx.fillStyle='#fff'; ctx.fill();
      // center text
      ctx.fillStyle='#374151'; ctx.font='bold 18px system-ui'; ctx.textAlign='center'; ctx.fillText(this.fmtCOP(total),cx,cy-4);
      ctx.fillStyle='#9ca3af'; ctx.font='11px system-ui'; ctx.fillText('TOTAL',cx,cy+16);
      // leyenda derecha
      const lX=cx+r_donut+30, lY0=PT+10, lH=24;
      labels.forEach((lbl,i)=>{
        const y=lY0+i*lH*1.3, pct=Math.round((vals[i]/total)*100);
        // dot
        ctx.fillStyle=cols[i]; ctx.beginPath(); ctx.arc(lX+6,y+6,6,0,2*Math.PI); ctx.fill();
        // label
        ctx.fillStyle='#374151'; ctx.font='12px system-ui'; ctx.textAlign='left'; ctx.fillText(lbl,lX+18,y+10);
        // valor
        ctx.fillStyle='#6b7280'; ctx.font='11px system-ui'; ctx.fillText(this.fmtCOP(vals[i])+' ('+pct+'%)',lX+18,y+24);
      });
      this.mCharts[key]={destroy:()=>ctx.clearRect(0,0,W,H)};
    },

    // ── Modal: barra horizontal grande ──────────────────────────────────────
    _modalBarH(key, data, fnLabel, fnVal, fnColor) {
		const cv = this.mCvs[key]; if (!cv) return;
		this.mCharts[key]?.destroy?.();
		const labels = data.map(fnLabel), vals = data.map(fnVal);
		if (!labels.length) return;

		const BH=28, GAP=14, PL=140, PR=60, PT=16, PB=28;
		const totalH = PT + labels.length * (BH + GAP) + PB;

		const ancho = cv.parentElement?.clientWidth
			|| cv.parentElement?.offsetWidth
			|| 860;

		cv.width  = ancho;
		cv.height = totalH;
		cv.style.width  = ancho + 'px';
		cv.style.height = totalH + 'px';

		const ctx = cv.getContext('2d');
		const W = cv.width, dW = W - PL - PR, maxV = Math.max(...vals) || 1;
		ctx.clearRect(0, 0, W, totalH);

		const steps = 5;
		for (let i = 0; i <= steps; i++) {
			const x = PL + (dW / steps) * i;
			ctx.strokeStyle = '#e8eaed'; ctx.lineWidth = 1;
			ctx.beginPath(); ctx.moveTo(x, PT); ctx.lineTo(x, totalH - PB); ctx.stroke();
			ctx.fillStyle = '#9ca3af'; ctx.font = '11px system-ui'; ctx.textAlign = 'center';
			ctx.fillText(this.fmtCOP(Math.round((maxV / steps) * i)), x, totalH - 8);
		}

		labels.forEach((lbl, i) => {
			const y = PT + i * (BH + GAP), bW = (vals[i] / maxV) * dW, r = 4;
			const col = fnColor(data[i]) || '#1e3a5f';

			ctx.fillStyle = '#374151'; ctx.font = '12px system-ui'; ctx.textAlign = 'right';
			ctx.fillText(this._truncate(lbl, 22), PL - 8, y + BH / 2 + 4);

			ctx.fillStyle = col;
			ctx.beginPath();
			ctx.moveTo(PL + r, y); ctx.lineTo(PL + bW - r, y);
			ctx.quadraticCurveTo(PL + bW, y, PL + bW, y + r);
			ctx.lineTo(PL + bW, y + BH - r);
			ctx.quadraticCurveTo(PL + bW, y + BH, PL + bW - r, y + BH);
			ctx.lineTo(PL + r, y + BH);
			ctx.quadraticCurveTo(PL, y + BH, PL, y + BH - r);
			ctx.lineTo(PL, y + r);
			ctx.quadraticCurveTo(PL, y, PL + r, y);
			ctx.closePath(); ctx.fill();

			if (bW > 20) {
				ctx.fillStyle = '#6b7280'; ctx.font = '11px system-ui'; ctx.textAlign = 'left';
				ctx.fillText(this.fmtCOP(vals[i]), PL + bW + 5, y + BH / 2 + 4);
			}
		});

		this.mCharts[key] = { destroy: () => ctx.clearRect(0, 0, cv.width, cv.height) };
	},

    // ── Openers modales ─────────────────────────────────────────────────────
    openmodalCarteraCompleta(){ this.modal_cartera  = true; },
    openmodalIngreso()        { this.modal_ingreso   = true; },
    openmodalFacturado()      { this.modal_facturado = true; },
    openmodalPagado()         { this.modal_pagado    = true; },
    openmodalGastado()        { this.modal_gastado   = true; },
    openmodalEgreso()         { this.modal_egreso    = true; },
    openmodalRecaudo()        { this.modal_recaudo   = true; },
    openmodalCompras()        { this.modal_compras   = true; },

    // ── Helpers ─────────────────────────────────────────────────────────────
    fmtNum(v)     { return new Intl.NumberFormat('es-CO').format(v ?? 0); },
    // Reemplaza fmtCompact y agrega fmtCOP
	fmtCOP(v) {
		if (!v && v !== 0) return '$0';
		if (v >= 1e9) return '$' + (v / 1e9).toFixed(1) + 'B';
		if (v >= 1e6) return '$' + (v / 1e6).toFixed(1) + 'M';
		if (v >= 1e3) return '$' + (v / 1e3).toFixed(0) + 'K';
		return '$' + new Intl.NumberFormat('es-CO').format(Math.round(v));
	},

	fmtNum(v) {
		// Formato COP completo: $ 1.234.567
		return new Intl.NumberFormat('es-CO', {
			style: 'currency',
			currency: 'COP',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		}).format(v ?? 0);
	},

	// fmtCompact ahora usa fmtCOP internamente — eliminar fmtCompact y usar fmtCOP directo
    _truncate(s, n) { return s && s.length > n ? s.slice(0,n)+'…' : (s||''); },
    _rndColor() {
      const r=Math.floor(Math.random()*100)+100, g=Math.floor(Math.random()*100)+100, b=Math.floor(Math.random()*100)+100;
      return '#'+(r<<16|g<<8|b).toString(16).padStart(6,'0');
    },
  },
};
</script>

<style scoped lang="scss">
$bg:#f7f7f7; $white:#fff; $navy:#0A354E; $g200:#e8eaed; $g500:#6b7280; $g700:#374151; $r:16px;

.db-wrap { background:$bg; min-height:100vh; }

/* ── Contable dashboard ── */
.ct-dashboard { padding:1.25rem .5rem; }
.ct-topbar { display:flex; justify-content:space-between; align-items:flex-end; margin-bottom:1.25rem; }
.ct-title    { font-size:1.5rem; font-weight:700; color:$g700; margin:0 0 .25rem; }
.ct-subtitle { font-size:.875rem; color:$g500; margin:0; }

/* KPI */
.ct-kpi-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:.75rem; margin-bottom:1.25rem; }
.ct-kpi-card {
  background:$white; border-radius:$r; border:1px solid $g200; padding:1rem 1.25rem;
  display:flex; align-items:center; gap:.875rem; transition:box-shadow .2s;
  &:hover { box-shadow:0 4px 16px rgba(0,0,0,.07); }
}
.ct-kpi-icon { width:36px; height:36px; border-radius:10px; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:1rem;} }
.ct-kpi-label { font-size:.62rem; font-weight:700; letter-spacing:.7px; text-transform:uppercase; color:$g500; margin-bottom:.2rem; }
.ct-kpi-value { font-size:1.05rem; font-weight:800; color:$g700; font-variant-numeric:tabular-nums; }

/* Section label */
.ct-section-label { font-size:.68rem; font-weight:700; letter-spacing:.8px; text-transform:uppercase; color:$g500; margin:.75rem 0 .6rem; }

/* Chart grid */
.ct-charts-grid { display:grid; grid-template-columns:repeat(2,1fr); gap:1rem; margin-bottom:1rem; }
.ct-chart-card { background:$white; border-radius:$r; padding:1.25rem 1.5rem; border:1px solid $g200; transition:box-shadow .2s; &:hover{box-shadow:0 4px 16px rgba(0,0,0,.07);} }
.ct-chart-header { display:flex; align-items:flex-start; justify-content:space-between; margin-bottom:1rem; }
.ct-chart-title  { font-size:.95rem; font-weight:700; color:$g700; }
.ct-chart-sub    { font-size:.75rem; color:$g500; margin-top:2px; }
.ct-link-btn { background:none; border:none; cursor:pointer; font-size:.8rem; font-weight:600; color:$navy; display:flex; align-items:center; gap:.3rem; white-space:nowrap; padding:0; i{font-size:.72rem; transition:transform .15s;} &:hover i{transform:translateX(3px);} }

/* Donut */
.ct-chart-body { display:flex; align-items:center; gap:1.5rem; }
.ct-donut-wrap { position:relative; flex-shrink:0; width:160px; height:160px; canvas{width:160px !important;height:160px !important;} }
.ct-donut-center { position:absolute; inset:0; display:flex; flex-direction:column; align-items:center; justify-content:center; pointer-events:none; }
.ct-donut-val { font-size:1.1rem; font-weight:800; color:$g700; line-height:1; font-variant-numeric:tabular-nums; }
.ct-donut-lbl { font-size:.58rem; font-weight:700; letter-spacing:1px; color:$g500; text-transform:uppercase; margin-top:2px; }

/* Legend */
.ct-legend { flex:1; display:flex; flex-direction:column; gap:.55rem; }
.ct-legend-item { display:grid; grid-template-columns:10px 1fr auto; align-items:center; gap:.4rem; font-size:.78rem; }
.ct-legend-dot   { width:10px; height:10px; border-radius:3px; flex-shrink:0; }
.ct-legend-label { color:$g700; font-weight:500; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.ct-legend-val   { font-weight:700; color:$g700; font-variant-numeric:tabular-nums; font-size:.75rem; }

/* Bar body */
.ct-bar-body { width:100%; min-height:80px; }
.ct-bar-body canvas { display:block; }

/* Modal */
.ct-dialog {
  :deep(.p-dialog-header) { font-weight:700; font-size:1rem; border-bottom:1px solid $g200; }
}
.ct-modal-total { display:flex; justify-content:space-between; align-items:center; padding:.75rem 1.5rem; background:#f8f9fa; border-bottom:1px solid $g200; }
.ct-modal-total-label { font-size:.7rem; font-weight:700; text-transform:uppercase; letter-spacing:.7px; color:$g500; }
.ct-modal-total-val   { font-size:1.25rem; font-weight:800; color:$g700; font-variant-numeric:tabular-nums; }
.ct-modal-chart-wrap { width:100%; min-height:300px; canvas { display:block; } }
.ct-modal-chart-wrap--bar { min-height:200px; }

/* Responsive */
@media(max-width:1100px){ .ct-kpi-grid{grid-template-columns:repeat(4,1fr);} }
@media(max-width:900px)  { .ct-kpi-grid{grid-template-columns:repeat(2,1fr);} .ct-charts-grid{grid-template-columns:1fr;} }
@media(max-width:768px)  {
  .ct-kpi-grid{grid-template-columns:repeat(2,1fr);}
  .ct-chart-body{flex-direction:column; align-items:flex-start; gap:1rem;}
  .ct-donut-wrap{width:140px;height:140px; canvas{width:140px !important;height:140px !important;}}
}
@media(max-width:480px)  { .ct-kpi-grid{grid-template-columns:1fr;} }
</style>